import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* createOrUpdateInsuranceCompany() {
  yield takeEvery(
    actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_REQUESTED,
    function* (action) {
      try {
        const result = yield call(
          actions.createOrUpdateInsuranceCompany,
          action.payload
        );
        yield put({
          type: actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_SUCCEEDED,
          payload: result,
        });
      } catch (error) {
        yield put({
          type: actions.CREATE_OR_UPDATE_INSURANCE_COMPANY_FAILED,
          error:
            error.response?.data?.message ||
            error.message ||
            "Request failed",
        });
      }
    }
  );
}

export default function* rootSaga() {
  yield all([fork(createOrUpdateInsuranceCompany)]);
}
